export var itemsIndexLengthKey = 'length';
// TODO: merge with MFSType property when it is ready
//Newly added MFSType property
// Thing.Collection.Space
// Thing.Document.TextDocument.Word// Thing.CalendarEvent
export var SpaceDataType;
(function (SpaceDataType) {
    SpaceDataType["Space"] = "Space";
    SpaceDataType["Section"] = "Section";
    SpaceDataType["Document"] = "Document";
    SpaceDataType["Link"] = "Link";
    SpaceDataType["CalendarEvent"] = "CalendarEvent";
    SpaceDataType["Other"] = "Other";
})(SpaceDataType || (SpaceDataType = {}));
//# sourceMappingURL=SpaceDataTypes.js.map